import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-dialog',
  templateUrl: './progress-dialog.component.html',
  styleUrls: ['./progress-dialog.component.css']
})
export class ProgressDialogComponent implements OnInit {
  isDone = false

  constructor() { }

  ngOnInit(): void {
  }

}
